import { scrollTo } from '@/utils/helpers';

export const BENEFITS_SECTION_ID = 'sections-benefits';

export function scrollToBenefits() {
  scrollTo(`#${BENEFITS_SECTION_ID}`, -30);
}
